import React, { useEffect, useState } from "react";
import { Table, Button, Row, Col, App, Drawer, Tooltip, Grid } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined,QuestionCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteCategory } from "../categoryThunks";
import { setSelectedCategory, setIsEditCategory } from "../categorySlice";
import { selectCategories } from "../../../store/commonSelectors/lookupsSelectors";
import { fetchCategories } from "../../../store/commonThunks/lookups";
import { getAccessType } from "../../../lib/functions";
import { useIsAdminUser } from "../../../lib/accessList";
const CategoryList = () => {
  const { modal } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const categories = useSelector(selectCategories);
  let [access_type, access_type_set] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [helpOpen, setHelpOpen] = useState(false);
  const isAdminUser = useIsAdminUser();
  const authInfo = useSelector((state) => state.auth?.auth_info);

  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;

  useEffect(() => {
    const access = getAccessType("item_category");
    access_type_set(access);
  }, []);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDelete = async (category_id, category_name) => {
    try {
      await dispatch(deleteCategory(category_id)).unwrap();
      modal.success({ title: "Category deleted successfully" });
      dispatch(fetchCategories());
    } catch (error) {
      modal.warning({ title: error.message || "Delete failed" });
    }
  };

  const columns = [
    {
      title: "NO.",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Category Name",
      dataIndex: "category_name",
      sorter: (a, b) => a.category_name?.localeCompare(b.category_name),
    },
    ...(access_type === "WRITE"
      ? [
        {
          title: "Actions",
          render: (_, record) => (
            <>
              <>
                <Button
                  type="link"
                  disabled={!(isAdminUser || canEdit)}
                  onClick={() => {
                    dispatch(setSelectedCategory(record));
                    dispatch(setIsEditCategory(true));
                    navigate("addNewCategory");
                  }}
                  icon={<EditOutlined />}
                />
                <Button
                  type="link"
                  danger
                  disabled={!(isAdminUser || canDelete)}
                  onClick={() =>
                    modal.confirm({
                      title: "Are you sure?",
                      content: `This will delete category: ${record.category_name}`,
                      okText: "Yes, Delete",
                      cancelText: "Cancel",
                      onOk: () =>
                        handleDelete(
                          record.category_id,
                          record.category_name,
                        ),
                    })
                  }
                  icon={<DeleteOutlined />}
                />
              </>
            </>
          ),
        },
      ]
      : []),
  ];

  useEffect(() => {
    dispatch(setSelectedCategory(null));
    dispatch(setIsEditCategory(false));
  }, [dispatch]);

  return (
    <>
      <Row justify="end" style={{ marginBottom: "32px", marginTop: "32px" }}>
      {/* <Row justify="space-between" align="middle" style={{ marginBottom: "32px", marginTop: "32px" }}> */}
         <Col>
          <Tooltip title="Help">
            <Button
              type="text"
              icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
              onClick={() => setHelpOpen(true)}
            />
          </Tooltip>
        </Col>
        <Col>
          {access_type == "WRITE" && (
            <>
              <Button
                type="primary"
                className="traic-button"
                icon={<PlusOutlined />}
                style={{
                  minWidth: "112px",
                  height: "36px",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
                onClick={() => {
                  dispatch(setSelectedCategory(null));
                  dispatch(setIsEditCategory(false));
                  navigate("/inventory/category/addNewCategory");
                }}
              >
                Add New
              </Button>
            </>
          )}
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={categories}
        rowKey="category_id"
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
        }}
        onChange={handleTableChange}
        scroll={{ x: "max-content" }}
      />
      <Drawer
        title="Category List Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Category Management
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Category Management module is used to view, create, update,
            and manage item categories within the ERP system. Categories help
            organize products for inventory tracking, filtering, and reporting.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Available Actions</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>View existing item categories</li>
              <li>Use <strong>Add New</strong> to create categories</li>
              <li>Edit category details using the edit icon</li>
              <li>Delete categories using the delete icon</li>
              <li>Search and review category information</li>
              <li>Manage product grouping for inventory operations</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Category names should remain unique for better organization.</li>
              <li>Deleting categories may affect linked inventory items.</li>
              <li>Access permissions control edit and delete actions.</li>
              <li>Categories improve inventory reporting and filtering.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default CategoryList;
